/** @type {string} */
const tooltipComponent = 'Tooltip';
export default tooltipComponent;
